import { useState, useEffect } from 'react';
import { LicenseAPI, LicenseObligations } from '../api';

export function useLicenseRules(licenseId: number | null, enabled: boolean) {
  const [data, setData] = useState<LicenseObligations | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!licenseId || !enabled) return;

    async function fetchRules() {
      try {
        setLoading(true);
        setError(null);
        const response = await LicenseAPI.getRules(licenseId as number);

        if (response.code === '200' && response.data) {
          setData(response.data);
        } else {
          setError(response.message || 'Failed to fetch license obligations');
        }
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
      } finally {
        setLoading(false);
      }
    }

    fetchRules();
  }, [licenseId, enabled]);

  return { data, loading, error };
}
